<template>
	<div class="container">

		<div class="loading" v-if="isDetail">
			<van-loading size="40px" type="spinner" color="#39CCCD" vertical>
				<div class="loading-text">
					<div>页面正在加载</div>
					<div>请稍候</div>
				</div>
			</van-loading>
		</div>

		<!-- 未支付展现的页面 -->
		<div class="header" v-if="!isDetail && visible">
			<div class="residue">剩余支付时间</div>

			<div class="paytime">
				<span class="time">{{ minutes }}</span>
				<span class="delimiter">:</span>
				<span class="time">{{ seconds }}</span>
				<span class="delimiter">:</span>
				<span class="time wd">{{ millisecond }}</span>
			</div>
			<div class="pay-btn" @click="getOrderDetail(true)">继续支付</div>
			<div class="overdue">逾时将不再享红包特惠</div>
		</div>

		<div class="content2" v-if="!isDetail && visible">
			<img :src="recordBg" class="record-bg" />
			<div class="item" v-for="item in listUser">
				<img :src="item.img" />
				<div class="right">
					<div class="name">{{ item.name }}</div>
					<div class="desc">{{ item.detail }}</div>
				</div>
			</div>
		</div>

		<div class="footer-fit" style="position: absolute;background-color: #fff;" v-if="!isDetail && visible">
			<div class="bottom2" @click="getOrderDetail(true)">立即支付</div>
		</div>

		<!-- 课程详情展示 -->
		<div class="content" v-html="detail.detail" v-show="!isDetail && !visible" @click="handleEnroll">
		</div>

		<div class="footer-fit" v-if="!isDetail && !detail.purchased && !visible">
			<div class="top">仅剩6个名额，请在
				<div class="top-size">{{ minutes }}</div>
				<div style="padding: 0 5px;">:</div>
				<div class="top-size">{{ seconds }}</div>
				<div style="padding: 0 5px;">:</div>
				<div class="top-size wt">{{ millisecond }}</div>
				内完成支付
			</div>
			<div class="center">
				<div class="center-left">
					<div class="left">
						<span>限时￥</span>
						<span class="size" v-if="detailPriceFlag">{{ detailPrice.left }}</span>
						<span class="size2" v-if="detailPriceFlag">.{{ detailPrice.right }}</span>
						<span class="size" v-if="!detailPriceFlag">{{ detail.price }}</span>
					</div>
					<div class="right">
						<div class="right-top">原价￥199</div>
						<div class="right-bottom">已优惠￥{{ 199 - detail.price }}</div>
					</div>
				</div>
				<div class="center-right" @click="handleEnroll">
					{{ detail.price <= 0 ? '立即报名' : '立即报名' }} </div>
				</div>
				<div class="bottom">
					<van-checkbox v-model="checked" checked-color="#ff6933" icon-size="14px"
						@change="checkbox"></van-checkbox>
					<div>
						<span class="pl">我已阅读并同意</span>
						<span class="size" @click="show3 = true">《个人信息授权与保护声明》</span>
					</div>
				</div>
			</div>

			<div class="footer-fit" v-if="!isDetail && detail.purchased">
				<div class="bottom2" @click="to_link()">已购此课，去加老师上课</div>
			</div>

			<!-- 手机验证码 -->
			<div v-if="show">
				<div class="popup_mengceng" @click="show = false"></div>
				<div class="popup-two">
					<div class="top">
						<div style="display: flex;align-items: center;">
							<van-icon name="checked" color="#00ff45" size="16px" />
							<div style="margin-left: 10px;">已通过安全认证，可放心填写</div>
						</div>
						<van-icon name="cross" color="#dcdee0" size="18px" class="icon" @click="closeShow" />
					</div>
					<div class="center">
						<div><input clearable v-model="form.phone" class="phone" placeholder="请输入手机号" type="tel"
								maxlength="11" :rules="rules" @focus="onFocus"></div>
						<div style="position: relative;" v-show="form.phone.length == 11">
							<input clearable v-model="form.sms" type="tel" class="sms" placeholder="请输入验证码"
								maxlength="6" :rules="rules" @focus="onFocus">
							<div slot="button" class="code-text" @click="getCode">{{ msgs }}<span
									v-show="isSend">后重试</span></div>
						</div>
					</div>
					<div class="bottom" @click="pay">{{ detail.price <= 0 ? '免费领取课程' : '立即支付' }} </div>
					</div>
				</div>

				<!-- 中层弹出 -->
				<div v-if="show2">
					<div class="popup_mengceng"></div>
					<div class="modals">
						<div class="modals_1">请等一下</div>
						<div class="modals_2">您有一份专属权益未使用，退出将失效</div>
						<div class="modals_3">
							<div style="padding-right: 10px;">优惠倒计时</div>
							<div class="top-size">{{ seconds }}</div>
							<div style="padding: 0 10px;">:</div>
							<div class="top-size wt">{{ millisecond }}</div>
						</div>
						<img src="@/assets/H5ui.png" style="width: 100%;" />
						<div class="modals_5">
							<div class="bottom_1" @click="btnModal(false)">残忍离开</div>
							<div class="bottom_2" @click="btnModal(true)">马上使用</div>
						</div>
					</div>
				</div>

				<!-- 个人信息授权与保护声明 -->
				<div v-if="show3">
					<div class="popup_mengceng" @click="show3 = false">
						<div class="popup_one">
							<div class="top">个人信息授权与保护声明</div>
							<div class="center" v-html="infoData.userRights"></div>
							<div class="bottom">
								<div class="scroll-bottom" @click="show3 = false">我知道了</div>
							</div>
						</div>
					</div>
				</div>

			</div>
</template>

<script>
var that;
import { checkStr } from '@/utils/validate'
import { Toast } from 'vant';
import wx from 'weixin-js-sdk'

export default {
	name: 'LoginIndex',
	components: {},
	props: {},
	data() {
		return {
			id: '',
			tid: '',
			recordBg: require('@/assets/record_bg.png'),
			isDetail: true,
			checked: true,
			form: {
				phone: '',
				sms: ''
			},
			detail: {
				price: 0,
				courseDetail: '',
				purchased: false
			},
			rules: [{
				required: true,
				message: '请输入手机号'
			}, {
				pattern: /^1\d{10}$/,
				message: '请输入正确的手机号'
			}],
			msgs: '获取验证码',
			token: '',
			show: false,
			show2: false,
			show3: false,
			isSend: false,
			orderId: '',
			status: '',
			users: {},
			minutes: '00',
			seconds: '00',
			millisecond: '0',
			countDownTime: 15 * 60 * 1000,
			infoData: {},
			isJump: false,
			visible: false,
			intervalId: null,
			timerTask: null,
			detailPrice: {
				left: 0,
				right: 0
			},
			detailPriceFlag: false,
			listUser: [{
				name: '陈静',
				img: require('@/assets/avatar1.jpg'),
				detail: '以前孩子写字真的很马虎，字迹潦草，每次家长会都被班主任点名批评。抱着试一试的态度加入了学小成写字训练营，不出5天孩子的字迹有了明显的提升，真的让人很惊讶'
			}, {
				name: '熊琪琪',
				img: require('@/assets/avatar2.jpg'),
				detail: '孩子现在写字越来越好看了，专注力也跟着提高了，学习状态比以前要好，在这里谢谢老师'
			}]
		}
	},
	computed: {},
	watch: {},
	created() {
		that = this
		that.id = this.$route.query.channel_id;
		that.tid = this.$route.query.tid || -1;
		that.token = localStorage.getItem('token') || '';
		that.visible = false

		// 设置倒计时间隔和初始更新
		that.clearTimer()
		that.countdownTime = new Date().getTime() + 5 * 60 * 1000 // 15分钟
		that.intervalId = setInterval(() => {
			that.updateCountdown(that.countdownTime)
		}, 200)

		that.getConfig();
		that.getInfosetting();
		that.getChannelsInfo();
		that.getOrderDetail();
		//有code去登录
		const queryObj = this.getQueryObj()
		if (queryObj['code']) {
			this.getLogin()
		}
	},
	destroyed() {
		this.clearTask()
	},
	methods: {

		//已购买训练营，如果训练营过期重新获取绑定最新训练营课程
		getAgainCourse() {
			this.$http.get('/app/users/updateTeacherByChannelId', {
				channelId: this.id
			}).then(res => {
				console.log('重新获取课程', res.data)
			})
		},

		getConfig() {
			var that = this
			this.$http.post('/u/app/mp/config', {
				url: window.location.href
			}).then(res => {
				const result = res.data
				wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端
					appId: result.appId, // 必填，公众号的唯一标识
					timestamp: result.timestamp, // 必填，生成签名的时间戳
					nonceStr: result.nonceStr, // 必填，生成签名的随机串
					signature: result.signature, // 必填，签名
					jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
				})
				wx.ready(() => {
					console.log('配置成功-fail-<')
					that.getReady()
				})
				// 当配置不成功时执行
				wx.error(res => {
					// 输出错误信息
					console.log('-配置不成功-fail-<', res)
					if (res.errMsg && res.errMsg.includes('the permission value isoffline verifying')) {
						wx.config({
							debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端
							appId: result.appId, // 必填，公众号的唯一标识
							timestamp: result.timestamp, // 必填，生成签名的时间戳
							nonceStr: result.nonceStr, // 必填，生成签名的随机串
							signature: result.signature, // 必填，签名
							jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
						})
						wx.ready(() => {
							console.log('配置成功2-fail-<')
							that.getReady()
						})
					}
				})
			})
		},

		getLogin() {
			//拿到code去登录
			that.token = localStorage.getItem('token') || '';
			if (that.token != '') {
				return
			}
			const queryObj = this.getQueryObj()
			this.$http.get('/u/app/login/mpLogin', {
				code: queryObj['code'],
				tid: that.tid,
				channelId: this.id
			}).then(res => {
				console.log("token", res.data)
				localStorage.setItem('token', res.data)

				that.$http.get('/app/channels/getOrder', {
					id: that.id,
				}).then(res => {
					if (!res.data) {//之前没有订单，跳转第二个页面
						that.show = true;
						return
					}

					// 状态(-1已取消0待付款1已付款)
					if (res.data.status === 1) {
						that.detail.purchased = true;
						that.getAgainCourse()
					}

					if (res.data.status === 0) {
						that.visible = true;
					}
				})

			}).catch(err => {
				//登录失效，清除token
				that.$toast('登录已失效,请退出再试')
				localStorage.removeItem('token')
				that.token = "";
			})
		},

		handleEnroll() {
			if (!this.checked) {
				this.$toast('请先确认协议')
				return
			}

			// 课程详情用户已购买直接跳转二维码页面
			if (this.detail.purchased) {
				this.to_link()
				return
			}

			that.token = localStorage.getItem('token') || '';
			if (that.token == '') {
				console.log('获取vx授权code')
				window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd06acaafd7167053&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`)
			} else {
				that.show = true;
			}

			// const queryObj = this.getQueryObj()
			// if (queryObj['code']) {
			// 	this.to_link(1)
			// } else {
			// 	console.log('获取vx授权code')
			// 	window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd06acaafd7167053&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`)
			// }
		},


		//获取验证码
		getCode() {
			if (!this.form.phone) {
				this.$toast('请输入手机号')
				return
			}
			if (!checkStr(this.form.phone, 'mobile')) {
				this.$toast('请输入正确的手机号')
				return
			}
			if (this.isSend) return

			this.$http.post('/u/ali/sms', {
				phone: this.form.phone
			}).then(res => {
				this.$toast('验证码已发送')
				let count = 60
				this.isSend = true
				this.msgs = count + 's'
				this.timer = setInterval(() => {
					if (count === 1) {
						this.isSend = false
						this.msgs = '获取验证码'
						clearInterval(this.timer)
						return
					}
					count--
					this.msgs = count + 's'
				}, 1000)
			})
		},

		pay() {
			var that = this;
			if (!that.form.phone) {
				that.$toast('请输入手机号')
				return
			}
			if (!checkStr(that.form.phone, 'mobile')) {
				that.$toast('请输入正确手机号')
				return
			}
			if (!that.form.sms) {
				that.$toast('请输入验证码')
				return
			}
			//判断验证码是否正确后再下单 
			this.$http.post('/app/users/verifyPhone', {
				phone: that.form.phone,
				smsCode: that.form.sms
			}).then(res => {
				that.show = false;
				that.getOrderDetail(true)
			}).catch(err => {
				that.$toast(err.msg)
			})
		},

		//下单
		addOrder() {
			var that = this;
			that.$http.post('/app/orders/add', {
				...that.detail,
				orderSource: '公众号',
				courseId: that.detail.courseId,
				phone: that.form.phone
				// grade: that.form.grade
			}).then(res => {
				that.orderId = res.data;
				if (that.detail.price !== 0) {//订单不是免费的则调起微信支付
					that.createPay()
				} else {
					that.$toast('领取成功')
					setTimeout(() => {
						that.to_link()
					}, 500);
				}
			}).catch(err => {
				that.$toast(err.msg)
			})
		},

		//isPay 是否手动点支付
		getOrderDetail(isPay = false) {
			that = this
			that.$http.get('/app/channels/getOrder', {
				id: that.id,
			}).then(res => {
				if (res.code == 401) {
					//token过期提示重新登录
					console.log('token过期就返回第一个页面')
					that.$toast('登录已失效，请重新再试')
					localStorage.removeItem('token')
					that.token = "";
					return
				}

				if (!res.data) {//之前没有订单，去生成订单
					if (isPay) {
						that.addOrder()
					}
					return
				}
				that.orderId = res.data.id
				that.status = res.data.status

				// 状态(-1已取消0待付款1已付款)
				if (res.data.status === 1) {
					that.clearTask()

					if (isPay) {
						that.$toast('领取成功')
						setTimeout(() => {
							that.to_link()
						}, 500);
					}
				}

				if (res.data.status === 0) {
					if (isPay) {
						that.createPay()
					} else {
						this.visible = true
					}
				}
			})
		},

		//去支付的时候变成true，手动点去支付重新变成false
		createPay(isJump = false) {
			var that = this;
			that.isJump = isJump
			that.$http.post('/app/orders/createPay', {
				id: that.orderId,
				payType: 3
			}).then(res => {
				if (res.data) {
					that.isJump = true;
					const result = res.data
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: result.appId, // 必填，公众号的唯一标识
						timestamp: result.timeStamp, // 必填，生成签名的时间戳
						nonceStr: result.nonceStr, // 必填，生成签名的随机串
						signature: result.paySign, // 必填，签名
						jsApiList: ['chooseWXPay']
					})
					wx.ready(function () {
						wx.checkJsApi({
							jsApiList: ['chooseWXPay'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
							success: function () { }
						})
					})
					wx.chooseWXPay({
						timestamp: result.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
						nonceStr: result.nonceStr, // 支付签名随机串，不长于 32 位
						package: result.packageVal, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
						signType: result.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
						paySign: result.paySign, // 支付签名
						success(res) {
							console.log('支付成功', res)
							that.clearTask()
							that.$toast('支付成功')
							setTimeout(() => {
								that.to_link()
							}, 500);
						},
						cancel: (err) => {
							console.log('取消支付', err)
							that.$toast('取消支付')
							that.visible = true;
							if (that.isJump) {
								that.startTask()
							}
						},
						fail: (err) => {
							console.log('支付失败', err)
							that.$toast('支付失败')
							that.visible = true;
							if (that.isJump) {
								that.startTask()
							}
						}
					})
				}
			}).catch(() => {
				that.getChannelsInfo()
				that.getOrderDetail()
			})
		},

		startTask() {
			this.clearTask()
			// 定时 查看成功的
			this.timerTask = setInterval(() => {
				this.token = localStorage.getItem('token')
				if (!this.token) {
					this.clearTask()
					return
				}
				this.$http.get('/app/channels/getOrder', {
					id: this.id
				}).then(res => {
					if (!res.data) {
						return
					}
					this.orderId = res.data.id
					this.status = res.data.status
					if (res.data.status === 1) {
						this.clearTask()
						this.getOrderDetail()
					}
				})
			}, 2000)
		},

		clearTask() {
			clearInterval(this.timerTask)
			this.timerTask = null
		},

		// 获取课程详情
		getDetail(id) {
			var that = this;
			this.$http.get('/u/app/courses/detail', {
				id: id
			}).then(res => {
				console.log("数据" + res)
				that.detail.purchased = res.data.purchased;
				if(res.data.purchased){
					that.getAgainCourse()
				}
			})
		},

		getChannelsInfo() {
			var that = this;
			this.$http.get('/app/channels/getInfo', {
				id: that.id
			}).then(res => {
				console.log("数据" + res)
				that.detail = res.data
				that.detail.detail = res.data.detail.replaceAll("<img ", "<img onclick='return false' ");
				document.title = res.data.title;

				// 判断是否带有小数点，有则截取逗号前后的数据
				var price = String(res.data.price);
				if (price.indexOf('.') > 0) {
					that.detailPriceFlag = true;
					that.detailPrice.left = price.split('.')[0];
					that.detailPrice.right = price.split('.')[1];
				}

				that.getDetail(res.data.courseId)

				setTimeout(() => {
					that.isDetail = false
				}, 500)
			}).catch(err => {
				setTimeout(() => {
					that.isDetail = false
					Toast('网络出现问题，请刷新重试!');
				}, 3000);
			})
		},

		to_link() {
			this.$router.push({
				path: '/vxPublic/success',
				query: { orderId: this.orderId }
			})
		},

		clearTimer() {
			clearInterval(this.intervalId)
			this.intervalId = null
		},

		updateCountdown(endTime) {
			const now = new Date().getTime()
			const distance = endTime - now

			if (distance < 0) {
				this.minutes = '00'
				this.seconds = '00'
				this.millisecond = '0'
				this.clearTimer()
				return
			}

			this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)) + ''
			this.seconds = Math.floor((distance % (1000 * 60)) / 1000) + ''
			this.millisecond = parseInt(Math.floor((distance % (1000 * 60)) % 1000) / 100) + ''
			this.minutes = this.minutes.length < 2 ? '0' + this.minutes : this.minutes
			this.seconds = this.seconds.length < 2 ? '0' + this.seconds : this.seconds
		},

		checkbox(e) {
			console.log("checkbox" + e)
			this.checked = e;
		},

		getReady() {
			var that = this;
			let shareUrl = window.location.href
			if (shareUrl.indexOf('code=') > 0) {
				shareUrl = shareUrl.match(/(\S*)&code=/)[1]
			}
			console.log('分享的链接', shareUrl)
			console.log('分享的内容', that.detail.courseName)
			wx.updateAppMessageShareData({
				title: `免费领>>5日趣味练字课`, // 分享标题
				desc: '5天写出漂亮字，每天练习15分钟，有1对1书法老师点评，让练字变简单！', // 分享描述
				link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
				imgUrl: 'https://mp.51xxc.com/courses/static/conrses_icon.png', // 分享图标
				success: function (res) {
					// 设置成功
					// wx.showMenuItems({
					//   menuList: ['menuItem:share:appMessage'] // 要显示的菜单项，所有menu项见附录3
					// })
					console.log('-22-分享success-<')
				},
				fail: e => {
					console.log('-22-分享fail-<', e)
				}
			})
			wx.updateTimelineShareData({
				title: `免费领>>5日趣味练字课`, // 分享标题
				desc: '5天写出漂亮字，每天练习15分钟，有1对1书法老师点评，让练字变简单！', // 分享描述
				link: shareUrl,
				imgUrl: 'https://mp.51xxc.com/courses/static/conrses_icon.png', // 分享图标
				success: function (res) {
					// 设置成功
					// wx.showMenuItems({
					//   menuList: ['menuItem:share:timeline'] // 要显示的菜单项，所有menu项见附录3
					// })
					console.log('-33-分享success-<')
				},
				fail: e => {
					console.log('-33-分享fail-<', e)
				}
			})
		},

		// 获用户详情
		getInfosetting() {
			this.$http.get('/u/app/appsetting/getInfo', { type: 1 }).then(res => {
				console.log("数据" + res)
				this.infoData = res.data
			})
		},

		// 获取地址栏的参数
		getQueryObj() {
			var query = window.location.search
			var queryObj = {}
			var arr = query.slice(1, query.length).split('&')
			arr.forEach(function (val) {
				var arr1 = val.split('=')
				queryObj[arr1[0]] = arr1[1]
			})
			return queryObj
		},

		btnModal(flag) {
			this.show2 = false;
			if (flag) {
				this.show = true;
			}
		},

		closeShow() {
			this.show = false;
			this.show2 = true;
		},

		onFocus(e) {
			setTimeout(() => {
				window.scrollTo({
					top: document.body.scrollHeight,
					behavior: 'smooth'
				});
			}, 400);
		}

	}
}
</script>

<style scoped lang="less">
.popup_mengceng {
	z-index: 2001;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, .7);
}


.modals {
	top: 25vh;
	left: 0;
	right: 0;
	width: 80%;
	padding: 20px;
	position: fixed;
	margin: 0 auto;
	z-index: 2002 !important;
	border-radius: 40px;
	background-color: #fff;

	.modals_1 {
		text-align: center;
		font-size: 36px;
		font-weight: bold;
		color: #000;
	}

	.modals_2 {
		text-align: center;
		font-size: 26px;
		color: #666;
		padding: 20px 0;
	}

	.modals_3 {
		font-size: 24px;
		color: #ff6a33;
		display: flex;
		align-items: center;
		justify-content: center;

		.top-size {
			background: #ff6a33;
			border-radius: 4px;
			color: #ffffff;
			padding: 0 4px;
			width: 40px;
		}

		.wt {
			width: 30px !important;
		}
	}

	.modals_5 {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;

		.bottom_1 {
			border: 2px solid #999;
			border-radius: 60px;
			width: 46%;
			height: 60px;
			line-height: 60px;
			color: #999;
			font-size: 24px;
			text-align: center;
		}

		.bottom_2 {
			border-radius: 60px;
			background-color: #ff6a33;
			width: 46%;
			height: 60px;
			line-height: 60px;
			color: #fff;
			font-size: 24px;
			text-align: center;
		}
	}
}

.popup-two {
	background-color: #fff;

	bottom: 0;
	left: 0;
	width: 100%;
	position: fixed;
	max-height: 100%;
	overflow-y: auto;
	background: #ffffff;
	border-radius: 50px 50px 0 0;
	z-index: 2002 !important;

	.top {
		display: flex;
		justify-content: center;
		font-size: 26px;
		color: #666;
		position: relative;
		padding: 40px 0;

		.icon {
			position: absolute;
			top: 40px;
			right: 20px;
		}
	}

	.center {
		margin: 20px 20px 80px 20px;

		.phone {
			border-radius: 20px;
			background-color: #f4f4f4;
			// padding: 30px 20px !important;
			font-size: 32px;
			width: 92%;
			padding: 30px 27px !important;
			border: none !important;
		}

		.code-text {
			color: #ff6933;

			position: absolute;
			top: 24px;
			right: 27px;
			bottom: 0;
			display: flex;
			align-items: center;
		}

		.sms {
			// position: relative;
			margin-top: 20px;
			background: #f5f5f5;
			border-radius: 20px;
			font-size: 32px;
			width: 92%;
			padding: 30px 27px !important;
			border: none !important;
		}
	}

	.bottom {
		margin: 20px 20px 40px 20px;
		background-color: #ff6933;
		border-radius: 60px;
		text-align: center;
		color: #fff;
		font-size: 36px;
		font-weight: bold;
		height: 96px;
		line-height: 96px;
	}
}

.popup_one {
	// width: 100%;
	top: 25vh;
	left: 0;
	right: 0;
	width: 80%;
	padding: 40px;
	position: fixed;
	margin: 0 auto;
	z-index: 2002 !important;
	border-radius: 40px;
	background-color: #fff;

	.top {
		font-size: 32px;
		font-weight: bold;
		text-align: center;
		padding-bottom: 20px;
	}

	.center {
		height: 360px;
		overflow-y: auto;
	}

	.bottom {
		display: flex;
		justify-content: center;
		margin-top: 40px;

		.scroll-bottom {
			border-radius: 60px;
			background-color: #ff6a33;
			width: 80%;
			height: 90px;
			line-height: 90px;
			color: #fff;
			font-size: 32px;
			font-weight: bold;
			text-align: center;
		}

	}
}

.content img {
	pointer-events: none;
	cursor: default;
}

.loading {
	margin: 40vh auto;
	text-align: center;

	.loading-text {
		color: #39CCCD;
		font-weight: bold;
	}
}

.container {
	color: #333;
	font-size: 28px;
	// height: 100vh !important;
	height: 100%;
	display: flex;
	flex-direction: column;

	.content {
		flex: 1;
		position: relative;
		// padding-bottom: 140px;
		// height: 100vh !important; 
		overflow-y: auto;

		::v-deep img {
			display: block;
			width: 100% !important;
		}
	}
}

.header-bg {
	width: 100vw;
}

.footer-fit {
	flex-shrink: 0;
	width: 100%;
	bottom: 0;
	z-index: 2;
	background-color: #fff;

	.top {
		background-color: #ffeee7;
		font-size: 26px;
		color: #ff6616;
		text-align: center;
		padding: 12px;
		display: flex;
		align-items: center;
		justify-content: center;

		.top-size {
			background: #ff6a33;
			border-radius: 4px;
			color: #ffffff;
			padding: 0 4px;
			width: 40px;
		}

		.wt {
			width: 30px !important;
		}
	}

	.center {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 20px;

		.center-left {
			display: flex;
			align-items: center;
			font-size: 32px;
			font-weight: 700;
			color: #ff5818;
			width: 58%;

			.left {
				font-size: 32px;

				.size {
					font-size: 60px;
				}

				.size2 {
					font-size: 32px;
				}
			}

			.right {
				margin-left: 20px;

				.right-top {
					text-decoration: line-through;
					font-size: 22px;
					color: #ff5818;
					font-weight: 500;
					opacity: 0.65;
				}

				.right-bottom {
					font-size: 20px;
					border: 0.5px solid #ff5818;
					border-radius: 4px;
					padding: 0 4px;
					font-weight: 500;
					margin-top: 8px;
					background: #ffe1d5;
				}
			}
		}

		.center-right {
			border-radius: 50px;
			background-color: #ff6933;
			font-size: 36px;
			color: #fff;
			font-weight: bold;
			text-align: center;
			width: 42%;
			height: 96px;
			line-height: 96px;
		}

	}

	.bottom {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20px;
		padding-bottom: 40px;
		font-weight: 500;

		.pl {
			padding-left: 4px;
		}

		.size {
			color: #ff6933;
		}
	}

	.bottom2 {
		color: #fff;
		margin: 20px 40px 40px 40px;
		background: #ff6933;
		border-radius: 60px;
		text-align: center;
		font-size: 36px;
		font-weight: bold;
		height: 96px;
		line-height: 96px;
	}
}


.header {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 32px;
	width: 684px;
	padding: 36px 0;
	border-radius: 20px;
	background-color: #fff;

	.paytime {
		color: #fe2d4d;

		.time {
			width: 48px;
			height: 48px;
			line-height: 48px;
			font-size: 36px;
			// border-radius: 6px;
			display: inline-block;
			color: #fe2d4d;
			font-weight: bold;
			// background: #fe2d4d;
		}

		.wd {
			width: 30px !important;
		}

		.delimiter {
			display: inline-block;
			margin: 0 8px;
			font-size: 36px;
			font-weight: bold;
		}
	}

	.pay-btn {
		width: 560px;
		margin-top: 30px;
		height: 88px;
		line-height: 88px;
		text-align: center;
		border-radius: 50px;
		font-weight: bolder;
		color: #fff;
		font-size: 40px;
		background: #fb7633;
	}

	.overdue {
		font-size: 24px;
		margin-top: 36px;
	}

	.residue {
		margin-bottom: 30px;
		font-size: 32px;
		font-weight: bold;
	}
}

.content2 {
	margin: 0 32px;
	width: 686px;
	// height: 300px;
	background: #fff;
	margin-top: 24px;

	.record-bg {
		width: 100%;
	}

	border-radius: 20px;

	.item {
		display: flex;
		padding: 24px 0;
		margin: 0 24px;
		border-bottom: 1px dashed #cccccc;

		&:last-child {
			border-bottom: none;
		}

		img {
			width: 60px;
			height: 60px;
			margin-right: 24px;
			border-radius: 30px;
		}

		.right {
			width: 554px;

			.name {
				margin-bottom: 30px;
				font-size: 32px;
				font-weight: bold;
			}

			.desc {
				color: #666;
				font-size: 28px;
			}
		}
	}
}

.van-popup {
	background: #f4f4f4;
}
</style>